// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"8114575f","376":"99b3c036","825":"2f1c4d69"}[chunkId] + ".chunk.js";
};